module.exports = __webpack_public_path__ + "img/41.60d79728.png";